module.exports = __webpack_public_path__ + "assets/img/20220509-1.c8ab95fb.png";